import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import hu from "@/plugins/hu.json";
import en from "@/plugins/en.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiURL: process.env.VUE_APP_API_URL,
    lang: hu,
    navigation_drawer: true,
    user: null,
    alert: {
      show: false,
      type: "success",
      message: "",
    },
    overlay: false,
  },
  mutations: {
    setOverlay(state, overlay) {
      state.overlay = overlay;
    },
    setLanguage(state, language) {
      language == "hu" ? (state.lang = hu) : (state.lang = en);
    },
    setUser(state, user) {
      state.user = user;
    },
    setAlert(state, alert) {
      state.alert.show = true;
      state.alert.type = alert.type;
      state.alert.message = alert.message;
    },
    hideAlert(state) {
      state.alert.show = false;
      state.alert.type = "success";
      state.alert.message = "";
    },
  },
  actions: {
    showAlert({ commit }, alertData) {
      commit("setAlert", alertData);
      setTimeout(() => {
        commit("hideAlert");
      }, 4000);
    },
  },
  modules: {},
  plugins: [
    createPersistedState({
      paths: [],
    }),
  ],
});
